module.exports = __webpack_public_path__ + "static/img/1569_phase_function_Paper_PointsHejduk_Prediction.06e1368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1569_phase_function_Paper_PointsHejduk_Prediction.png
// module id = UdLt
// module chunks = 0